import { Component } from '@angular/core';

@Component({
    template: `<button FinishOption004 finishOption001 type="buttton">Prueba</button>` 
  })

  export class FinishOptionComponent {
  }